/**
 * This page loads inside the MSAL popup.
 * It calls handleRedirectPromise() on the SAME msalInstance config.
 * MSAL internally communicates between popup and parent via localStorage/BroadcastChannel.
 * The popup closes automatically when handleRedirectPromise() completes.
 */
import { useEffect, useState } from 'react'
import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from '../../../utility/auth/msalConfig'

export default function RedirectPage() {
  const [msg, setMsg] = useState('Completing sign-in…')

  useEffect(() => {
    ;(async () => {
      try {
        const instance = new PublicClientApplication({
          auth: {
            ...msalConfig.auth,
            redirectUri: `${window.location.origin}/redirect.html`,
          },
          cache: msalConfig.cache,
          system: {
            // Allow this instance to handle popup responses
            allowNativeBroker: false,
          },
        })
        await instance.initialize()
        await instance.handleRedirectPromise()
        setMsg('Done ✓')
        // MSAL closes the popup automatically after handleRedirectPromise
        // If not, close manually after a short delay
        setTimeout(() => window.close(), 1000)
      } catch (e) {
        console.error(e)
        setMsg('Error — close this window')
      }
    })()
  }, [])

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      gap: 12, fontFamily: 'system-ui', background: '#f9fafb',
    }}>
      {msg === 'Completing sign-in…' && (
        <>
          <div style={{
            width: 28, height: 28,
            border: '3px solid #e5e7eb', borderTopColor: '#28C29C',
            borderRadius: '50%', animation: 'spin 0.75s linear infinite',
          }} />
          <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
        </>
      )}
      <p style={{ color: '#9ca3af', fontSize: 13, margin: 0 }}>{msg}</p>
    </div>
  )
}